export const arrayEmpty = [];
export const objectEmpty = {};

export const toLog = (text, data) => {
  //console.log(text, data);
}